export default "__VITE_ASSET__ClIFdS$k__"